import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=fc8d3998&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"
import style0 from "./posts.vue?vue&type=style&index=0&id=fc8d3998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8d3998",
  null
  
)

export default component.exports